import DecoupledDocumentEditor from '@ckeditor/ckeditor5-editor-decoupled/src/decouplededitor';

// Plugins
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Link from '@ckeditor/ckeditor5-link/src/link';
//import List from '@ckeditor/ckeditor5-list/src/list';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor';
import FontSize from '@ckeditor/ckeditor5-font/src/fontsize';
import FontFamily from '@ckeditor/ckeditor5-font/src/fontfamily';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
//import NumberedList from '@ckeditor/ckeditor5-list/src/numberedlist';
//import BulletedList from '@ckeditor/ckeditor5-list/src/bulletedlist';
import Blockquote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import Table from '@ckeditor/ckeditor5-table/src/table';
//import Undo from '@ckeditor/ckeditor5-undo/src/undo';
//import Redo from '@ckeditor/ckeditor5-undo/src/redo';
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting';

//import List from '@ckeditor/ckeditor5-list';
//import List from '@ckeditor/ckeditor5-list';
import { ListEditing, ListUI } from '@ckeditor/ckeditor5-list';

import Undo from '@ckeditor/ckeditor5-undo/src/undo';
import UndoEditing from '@ckeditor/ckeditor5-undo/src/undoediting';
import UndoUI from '@ckeditor/ckeditor5-undo/src/undoui';

import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript';
import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript';

import Eqneditor5 from '@codecogs/eqneditor-ckeditor5/src/eqneditor5';
import Image from '@ckeditor/ckeditor5-image/src/image';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';

import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';


export default class DecoupledEditor extends DecoupledDocumentEditor { }

DecoupledEditor.builtinPlugins = [
  Essentials,
  Autoformat,
  Bold,
  Italic,
  BlockQuote,
  Heading,
  Link,
  //List,
  Paragraph,

  FontColor,
  FontSize,
  FontFamily,
  Underline,
  Strikethrough,
  Alignment,
  Superscript,
  Subscript,
  //NumberedList,
  //BulletedList,
  ListEditing,
  ListUI,
  Blockquote,
  Table,
  Undo,
  //Redo,
  UndoEditing,
  UndoUI,
  SourceEditing,
  // ... and any other plugins you want to include
  Eqneditor5,
  Image,
  MediaEmbed,
  Indent,       // Add Indent plugin
  IndentBlock,  // Add IndentBlock plugin
];

DecoupledEditor.defaultConfig = {
  toolbar: {
    items: [
      'heading',
      '|',
      'bold',
      'italic',
      'link',
      'bulletedList',
      'numberedList',
      'blockQuote',
      'undo',
      'redo'
    ]
  },
  // The rest of the default configuration
};
